/// <amd-module name="VSSUI/Components/VssIcon/VssIcon" />

import * as React from "react";
import { Icon, IconType, IIconProps } from "OfficeFabric/Icon";
import { css } from "VSSUI/Util";
import { IVssIconProps, VssIconType } from "../../Components/VssIcon/VssIcon.Props";

import "VSS/LoaderPlugins/Css!VSSUI/Components/VssIcon/VssIcon";

/** @deprecated */
export class VssIcon extends React.Component<IVssIconProps> {
    private static readonly bowtieIconPrefix = "bowtie-";

    constructor(props: IVssIconProps) {
        super(props);

        this.state = {};
    }

    public render(): JSX.Element {
        return <Icon {...VssIcon.getIconProps(this.props)}>{this.props.children}</Icon>;
    }

    /**
     * Convert IVssIconProps to Fabric's IIconProps. To use with components such as IconButton
     * that take IIconProps. This is a pure function.
     * @param props
     * @param className Additional CSS class name to apply to the returned icon
     * @return
     */
    public static getIconProps(props: IVssIconProps, className?: string): IIconProps {
        const fabricIconProps: IIconProps = { ...props } as any;
        delete fabricIconProps.iconType;
        delete fabricIconProps.iconName;

        // If IconType is not specified, but the iconName includes the "bowtie-", then set icon type to bowtie.
        let passedIconType = props.iconType;
        if (!passedIconType && props.iconName && props.iconName.substr(0, VssIcon.bowtieIconPrefix.length) === VssIcon.bowtieIconPrefix) {
            passedIconType = VssIconType.bowtie;
        }

        // IconType is either image or default.
        fabricIconProps.iconType = props.iconType === VssIconType.image ? IconType.image : IconType.default;

        const vssIconClass = css("vss-Icon", className);
        if (fabricIconProps.className) {
            fabricIconProps.className = `${fabricIconProps.className} ${vssIconClass}`;
        } else {
            fabricIconProps.className = vssIconClass;
        }

        if (passedIconType === VssIconType.bowtie) {
            let iconName = props.iconName;
            if (typeof iconName === "string" && iconName.substr(0, VssIcon.bowtieIconPrefix.length) !== VssIcon.bowtieIconPrefix) {
                iconName = VssIcon.bowtieIconPrefix + iconName;
            }

            const newClasses = css("vss-Icon--bowtie", iconName);
            fabricIconProps.className = `${fabricIconProps.className} ${newClasses}`;
        } else {
            fabricIconProps.iconName = props.iconName;
        }

        return fabricIconProps;
    }
}
